// extracted by mini-css-extract-plugin
module.exports = {"pc_only":"TextArea__pc_only___3BsXS","sp_only":"TextArea__sp_only___AUG5M","textarea":"TextArea__textarea____970B"};